
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutG3JKbe32VG2iDQ0BBiSt_g_45TLSrp0Fi2tTuZI6fmlkoMeta } from "/root/gastos-gub-uy/app/pages/about.vue?macro=true";
import { default as indexeFDzzWHCOcW1Gu0c8A9YckZH0CuXb5bjkvMGoPZJ2p8Meta } from "/root/gastos-gub-uy/app/pages/index.vue?macro=true";
import { default as loginHAZcx5GRyUbP9cSL_45KulMqyW9GIMDuhVdUyqE_E57QkMeta } from "/root/gastos-gub-uy/app/pages/login.vue?macro=true";
import { default as pautajwXne_LbkOO_452HvTcAn7p_45idDX3Jey0zldGmBF8bqPsMeta } from "/root/gastos-gub-uy/app/pages/pauta.vue?macro=true";
import { default as cookiesNHFBCSYiGNNW8_458zDZRJyDv7y7zyw8rSKwaCgrCkMQMMeta } from "/root/gastos-gub-uy/app/pages/cookies.vue?macro=true";
import { default as registronU_A_nlNkq0uxJlpYHiwpW6I7YpY2_45KpMtfTfQgLkJ0Meta } from "/root/gastos-gub-uy/app/pages/registro.vue?macro=true";
import { default as terminosVD_xNdV5Nr3tjCppVqpOf7Q7M2m5T0lLaLm8sTdXFjEMeta } from "/root/gastos-gub-uy/app/pages/terminos.vue?macro=true";
import { default as indexHdtqsl9On2xHYKvGpFtQJTlcok4rP8Ea4REqVkyf8xgMeta } from "/root/gastos-gub-uy/app/pages/app/index.vue?macro=true";
import { default as recuperarqa_fo4EBcrEHGfr2Bfq8twUB1Jj2vBLv4qekbwQQxikMeta } from "/root/gastos-gub-uy/app/pages/recuperar.vue?macro=true";
import { default as cuenta6Wy5qtXF24y7XoLUziGAwjJcO58sGE_xNl_45WmndRWSIMeta } from "/root/gastos-gub-uy/app/pages/app/cuenta.vue?macro=true";
import { default as index40J_aGXgoQaC33HMf_45lK21C7d5dhSYNJCyQqHJzTgRUMeta } from "/root/gastos-gub-uy/app/pages/blog/index.vue?macro=true";
import { default as developersq6v4hpi3Za0DQ_qRuCcZp4qkwowYWyuqjQUYoooavasMeta } from "/root/gastos-gub-uy/app/pages/developers.vue?macro=true";
import { default as privacidadPdro5rmHPg_45Xvo8UsM3njZ9U6TdgAEW_1M7Xv_mMOhoMeta } from "/root/gastos-gub-uy/app/pages/privacidad.vue?macro=true";
import { default as alertasZAOl6u8QEyUEVXsbSy8L3JXPGcMEcnrSaDxKsH7BgsAMeta } from "/root/gastos-gub-uy/app/pages/app/alertas.vue?macro=true";
import { default as _91slug_931mJmVuCC8fVPZ5lvgY3_45RT2Sez5pjgwXTo7mvWv1_HEMeta } from "/root/gastos-gub-uy/app/pages/blog/[slug].vue?macro=true";
import { default as _91id_93NlXFV1RK0D4CyyuQ_TsTzi4t0fNBVkw4HfXDF2FgI_0Meta } from "/root/gastos-gub-uy/app/pages/buyers/[id].vue?macro=true";
import { default as comparativaV2m5BdaZX0PXPRHWbHA_FdezoB6a_ZrF1yAFbqUBtVQMeta } from "/root/gastos-gub-uy/app/pages/comparativa.vue?macro=true";
import { default as unsubscribeCnlKMaHmbu_n6LEEFDEfp6P4jQ5iZelnuTGdQ2jjJskMeta } from "/root/gastos-gub-uy/app/pages/unsubscribe.vue?macro=true";
import { default as api_45keystEVcouzTONXvzOvkTlGiSYexC5nduyHgI_45ov1P6p5RwMeta } from "/root/gastos-gub-uy/app/pages/app/api-keys.vue?macro=true";
import { default as webhooksxGnW12JpggbYzVZjl_45I97tDx_45mxhmFqH4Y6u3Qk65IAMeta } from "/root/gastos-gub-uy/app/pages/app/webhooks.vue?macro=true";
import { default as index7iHvlRMEgb5ougucvN7NX_UkQSidiqctRaJybHM_OGsMeta } from "/root/gastos-gub-uy/app/pages/buyers/index.vue?macro=true";
import { default as indexl5iStkIZrsaooMPnCBF9SrXr1qfZaKGKsOrp1Kyyf1EMeta } from "/root/gastos-gub-uy/app/pages/curros/index.vue?macro=true";
import { default as estadisticasjk5FuAGkBedqEjaW5AMu7yW_45Sb82fyFuR3_456noBQUzQMeta } from "/root/gastos-gub-uy/app/pages/estadisticas.vue?macro=true";
import { default as indexHZjvhS_45XLhRTEqNNkHQZ29MV1NWmR_458h1pS3KpQnbJwMeta } from "/root/gastos-gub-uy/app/pages/gastos/index.vue?macro=true";
import { default as callbacknAimpv7Zl1xoZHZaJfldAbrsFOlwuZq9a_45UdTQ5lyYUMeta } from "/root/gastos-gub-uy/app/pages/auth/callback.vue?macro=true";
import { default as colaboradoresFY0rBhZ1ZEaBXxQ_W6cnvZ4xAreirVEETDJmLh8qQJMMeta } from "/root/gastos-gub-uy/app/pages/colaboradores.vue?macro=true";
import { default as _91slug_93Kfx1fVo3evOmV3NMFoyu1kuTppmxBuh5e7iupIs7YiEMeta } from "/root/gastos-gub-uy/app/pages/curros/[slug].vue?macro=true";
import { default as _91year_93lrqpApvVnW0gYkhMTGh4lvFu_45mtFBdiHhJM6xVkOE5oMeta } from "/root/gastos-gub-uy/app/pages/gastos/[year].vue?macro=true";
import { default as mapakB422aMY522M_W2FhyzhLvBsCOaTTvlcqNgswrad6IIMeta } from "/root/gastos-gub-uy/app/pages/analytics/mapa.vue?macro=true";
import { default as calendarioJvOCWM_45UWenwF0S1nBKMX6wwI_45dCK9NxL1MDFXhTexkMeta } from "/root/gastos-gub-uy/app/pages/app/calendario.vue?macro=true";
import { default as _91id_93UAG0L8sLx8Dh78pIsGb_451QJqJUpZyDUcEzn58Lb1XE4Meta } from "/root/gastos-gub-uy/app/pages/contracts/[id].vue?macro=true";
import { default as indexXXjvm_452w85tgzPGKPv4dd0n69sg40MhZM5Tkw8HwqF8Meta } from "/root/gastos-gub-uy/app/pages/llamados/index.vue?macro=true";
import { default as indexWR13lrDYd1rbV0b4QFU4oBGzNQsBddeaEr0FYFnDga4Meta } from "/root/gastos-gub-uy/app/pages/products/index.vue?macro=true";
import { default as indexi_45y3KoCz7rax3kjlag7ihDxQ_456JD6cE_IHMOvr1l4DIMeta } from "/root/gastos-gub-uy/app/pages/analytics/index.vue?macro=true";
import { default as index65luhlXYpHvAloj2VBv5EbZ21hPfA198AGYAJYJ4cy4Meta } from "/root/gastos-gub-uy/app/pages/contactos/index.vue?macro=true";
import { default as indexcZhJ8YMHyeuzFhe4wYPMTHG4gYq3hiCfCbUKTY8RIGoMeta } from "/root/gastos-gub-uy/app/pages/contracts/index.vue?macro=true";
import { default as _91code_93UIdQq_YWduxxEpJb8RipMTO1xIO57OVrPfRfRi3s6O0Meta } from "/root/gastos-gub-uy/app/pages/products/[code].vue?macro=true";
import { default as indexSBd8AudDTGNz_TaZrOAMNfLTmUDqRSc3PYNl2dCLYhAMeta } from "/root/gastos-gub-uy/app/pages/suppliers/index.vue?macro=true";
import { default as agendaYcsdPgjny_45i80JhH6M47nI0ISYhwLyXTSD16gf2LdbkMeta } from "/root/gastos-gub-uy/app/pages/analytics/agenda.vue?macro=true";
import { default as generoCdVfMjPHyb532tVsNJQxgzg_mBAYmr10_45xO441zB8RgMeta } from "/root/gastos-gub-uy/app/pages/analytics/genero.vue?macro=true";
import { default as omisoswqH6LUUDQUtA_l1E9jFZ0ZnU5NTOnjIqN4Q7MRXxPiwMeta } from "/root/gastos-gub-uy/app/pages/analytics/omisos.vue?macro=true";
import { default as indexUnkqdm3NI1le3f0zgB_FidjdD7Po63WgEG8WdYlGLQwMeta } from "/root/gastos-gub-uy/app/pages/parlamento/index.vue?macro=true";
import { default as senales9y5QsiRKvJh5lCUnroqmTBnlTu72GsVZ2COxeNwh7lMMeta } from "/root/gastos-gub-uy/app/pages/analytics/senales.vue?macro=true";
import { default as _91_46_46_46id_93z7dykPw7vUwORCIgq6YcTg2oZJFTdExDWgGZXVbmnJEMeta } from "/root/gastos-gub-uy/app/pages/suppliers/[...id].vue?macro=true";
import { default as partidosMgcrFf8697agboXBZYxiQ5mhC83bPM2iptAN0PrXAA4Meta } from "/root/gastos-gub-uy/app/pages/analytics/partidos.vue?macro=true";
import { default as notificacionesNSmBqkkt9kfAUFtf0eTGA3YaosPynSba7uw7e31d9ZMMeta } from "/root/gastos-gub-uy/app/pages/app/notificaciones.vue?macro=true";
import { default as anomaliesgBKn49DDFV0u_2dlxdGO_45Lve9_45_45IvIxhjN1Ct_iYunAMeta } from "/root/gastos-gub-uy/app/pages/analytics/anomalies.vue?macro=true";
import { default as encuestasHluMS7MYKxxp_yaLUGvGD6p3f1mEJJAFSCAqefc2glEMeta } from "/root/gastos-gub-uy/app/pages/analytics/encuestas.vue?macro=true";
import { default as sancionesje4sK7z669fdn3_Pr5lfbvXjRkhuerBnzbs9_KhrEEkMeta } from "/root/gastos-gub-uy/app/pages/analytics/sanciones.vue?macro=true";
import { default as _91compraId_9330Rjuv3ISQcEOqWDr_eKXKCThEB_450UPtF_45nwVEeeri0Meta } from "/root/gastos-gub-uy/app/pages/llamados/[compraId].vue?macro=true";
import { default as organismosAgHjOzofc_mA64S1CzCJakwbm3Q0sKkdJnqTrmaJIWsMeta } from "/root/gastos-gub-uy/app/pages/analytics/organismos.vue?macro=true";
import { default as sentenciasWbHn9par6FN3wUbHRsgIoh9R9ZBFUKLVRLMovMbt7O8Meta } from "/root/gastos-gub-uy/app/pages/analytics/sentencias.vue?macro=true";
import { default as _91videoId_93XNbVInTr6fGEZFovtvUCf_omasFE95JRwGXo0RQl4DIMeta } from "/root/gastos-gub-uy/app/pages/parlamento/[videoId].vue?macro=true";
import { default as indexxcix0qrsTZq4WiXnIdxv_6iGMhf7JY2tjzO1vWJXAOcMeta } from "/root/gastos-gub-uy/app/pages/recopilatorios/index.vue?macro=true";
import { default as competencia4lR80PIaEKwNhGfcgoxdj_45AF5e_2_45Pq1VxnyvRhrRKQMeta } from "/root/gastos-gub-uy/app/pages/analytics/competencia.vue?macro=true";
import { default as unexplainedjLHa8gRWhmNE_45aw9ByK6jmSm4TEvZGl6T94D9euLRUwMeta } from "/root/gastos-gub-uy/app/pages/analytics/unexplained.vue?macro=true";
import { default as indexPSygtZKGt6uMtkoTyeTP1RjscO3k3VCe9nnGz_NoR6oMeta } from "/root/gastos-gub-uy/app/pages/canales-youtube/index.vue?macro=true";
import { default as index4r_45WZck7AFzoc6jtiuPNK6QWcE58SwKw1aINgnZ_uiYMeta } from "/root/gastos-gub-uy/app/pages/investigaciones/index.vue?macro=true";
import { default as suncadru52DsrrTBCk6XbzMhuRDqGDwKDaX27m666p3GOIF0Meta } from "/root/gastos-gub-uy/app/pages/investigaciones/sunca.vue?macro=true";
import { default as _91slug_93gUkpnW1SaC4IV9_45YtXMEhU6YAWvxm3o0ivaLJH4uDp0Meta } from "/root/gastos-gub-uy/app/pages/recopilatorios/[slug].vue?macro=true";
import { default as anticipacion1oy9TY3zthGFGhLISMuguW7_4530DA7zZWioEzbsUjJe0Meta } from "/root/gastos-gub-uy/app/pages/analytics/anticipacion.vue?macro=true";
import { default as intendencias6Uz11ZT_jNWrupAWQUpgk5hIcYd1NwrZhv9JjXwueC4Meta } from "/root/gastos-gub-uy/app/pages/analytics/intendencias.vue?macro=true";
import { default as _91slug_93JnkaKOIIomxQGejnblX6_45OlNd26r2D1yjC2tmYZNT8oMeta } from "/root/gastos-gub-uy/app/pages/canales-youtube/[slug].vue?macro=true";
import { default as unsubscribeKYU7V9XozTcRiqMzgXxlD0IWTLYMXj9YTR6OWVPYKOQMeta } from "/root/gastos-gub-uy/app/pages/newsletter/unsubscribe.vue?macro=true";
import { default as como_45reportarEG_L8hpcGrjEBjNqgH0cxXWGv5JjBuFpEd_45toyZj3N8Meta } from "/root/gastos-gub-uy/app/pages/analytics/como-reportar.vue?macro=true";
import { default as errores_45carga5f9BibsDjO7bYXC5DuaSaGq_45TIdhCnf97KInWDcGwuEMeta } from "/root/gastos-gub-uy/app/pages/analytics/errores-carga.vue?macro=true";
import { default as rss_45anomaliasx7g_45txw3wXjd6CQOc2YhiQAyEeucIubNcXaRPL86uOMMeta } from "/root/gastos-gub-uy/app/pages/analytics/rss-anomalias.vue?macro=true";
import { default as casinosQu3rIlWaPwms41dvN7p1X_zHGrm5kKZXB9LtLZox9AYMeta } from "/root/gastos-gub-uy/app/pages/investigaciones/casinos.vue?macro=true";
import { default as evolucion_45gastoJjio513f6GNj0oWEF2VXbXAxZ0Zdw7AVJfVJbHdmDGwMeta } from "/root/gastos-gub-uy/app/pages/analytics/evolucion-gasto.vue?macro=true";
import { default as comparativa_45transparenciaeKXDJ71gk57rz2DuY3CaxomIoyGHiGe5GEPe1SZVSr8Meta } from "/root/gastos-gub-uy/app/pages/comparativa-transparencia.vue?macro=true";
import { default as hallazgos_JzAbyBHUx9623an9Mgy_mrilAek99LyL0TuP_vktnsMeta } from "/root/gastos-gub-uy/app/pages/investigaciones/hallazgos.vue?macro=true";
import { default as suicidioswT_45Fqxs95lpYi3hcgYxKrJVMlTgVSjDWUwkzmbXfqHsMeta } from "/root/gastos-gub-uy/app/pages/investigaciones/suicidios.vue?macro=true";
import { default as tv_45ciudadSCxNCnWxRl3p11WEHjcprrXnNzJtPUXCKjtcNREk7McMeta } from "/root/gastos-gub-uy/app/pages/investigaciones/tv-ciudad.vue?macro=true";
import { default as tribunal_45cuentasRzvLqaFtqZB3ivCdCq1SWJTiLTXq2r9ICgQ9dGZa6QAMeta } from "/root/gastos-gub-uy/app/pages/analytics/tribunal-cuentas.vue?macro=true";
import { default as monopoliosJ8pswbj3LVdVsNYiN0UHzoDx137o8QychLQCxO9pOncMeta } from "/root/gastos-gub-uy/app/pages/investigaciones/monopolios.vue?macro=true";
import { default as mapaqycxngGRWdsDKyHA6DvxxG77svemk7D9qjnfLTTakrcMeta } from "/root/gastos-gub-uy/app/pages/proveedores/contactos/mapa.vue?macro=true";
import { default as indext3FY9YfyPpmMhP6_Gvgy_F2BIeQP6M2M0A8wsLLY1UwMeta } from "/root/gastos-gub-uy/app/pages/investigaciones/casos/index.vue?macro=true";
import { default as indexSgFZw3lAfMJgqrkoORX9zx8S_dgmg1ZKXfEhyoKtYCMMeta } from "/root/gastos-gub-uy/app/pages/proveedores/contactos/index.vue?macro=true";
import { default as _91slug_930cRDWQu6JZESemfRfF7x2WZRq7qJEGHIVSQh3ezuLVEMeta } from "/root/gastos-gub-uy/app/pages/investigaciones/casos/[slug].vue?macro=true";
import { default as indexXmmu_4519yGZY8Rr6VyqgQLOvnV42Bl1xwwrU6tPGRFG0Meta } from "/root/gastos-gub-uy/app/pages/investigaciones/diario/index.vue?macro=true";
import { default as documento_45faCGUfiL8kX_R0DLYjmMu87ZYJ7pJp7taK5tfAj_459MCvYMeta } from "/root/gastos-gub-uy/app/pages/investigaciones/documento-fa.vue?macro=true";
import { default as mejor_45o_45peor87P5ICps5yoCmGklNH_3fZMlB4d8AKaZ6x7L7GrHvfkMeta } from "/root/gastos-gub-uy/app/pages/investigaciones/mejor-o-peor.vue?macro=true";
import { default as _91tema_930YyqvBWQXifWocu4NJOVcGvCK47pvS6Y6YVjG5Si4sMMeta } from "/root/gastos-gub-uy/app/pages/investigaciones/temas/[tema].vue?macro=true";
import { default as _91slug_93tLeXDWbMkL8vVEZbheyi4euHumsqEjDYN9TKpLSQ9XsMeta } from "/root/gastos-gub-uy/app/pages/investigaciones/diario/[slug].vue?macro=true";
import { default as proveedores_45anomalias95sallqFU98kX9JFHOvU_45rB4YO49PUm_45h_45t8Pm31ehMMeta } from "/root/gastos-gub-uy/app/pages/analytics/proveedores-anomalias.vue?macro=true";
import { default as gasto_45en_45genero0CkAvSA35XaYLCOWpl3yY_7OjOcXB0BrGq5rkUE_45djUMeta } from "/root/gastos-gub-uy/app/pages/investigaciones/gasto-en-genero.vue?macro=true";
import { default as antel_45cuadrillasZxoHS90k5SPJzy7tlwejM0twqiw5qA8iT_45hyx711htEMeta } from "/root/gastos-gub-uy/app/pages/investigaciones/antel-cuadrillas.vue?macro=true";
import { default as asse_45ambulanciasnHeDfSLg1CcTcNnB7lffrrgaOB144y_50Z1AymwCUPYMeta } from "/root/gastos-gub-uy/app/pages/investigaciones/asse-ambulancias.vue?macro=true";
import { default as canales_45privados7Dyyz3pC23aRIzco__PLeSlZYTKlGtOxWR6Pje2CekwMeta } from "/root/gastos-gub-uy/app/pages/investigaciones/canales-privados.vue?macro=true";
import { default as casinos_45cortesia7pzO8NZnApX6I1PD6mlV5mQyAqvYW2dgm1WF5R2JBqMMeta } from "/root/gastos-gub-uy/app/pages/investigaciones/casinos-cortesia.vue?macro=true";
import { default as soriano_45talleresAar2m_J872TEC4EcX7vyfjgE3C5znCg1bEHRkfq1Uw4Meta } from "/root/gastos-gub-uy/app/pages/investigaciones/soriano-talleres.vue?macro=true";
import { default as datacenter_45google_sSHL4XxR4iVmlxXhSG63FmsM1N3S0W09cE9TuRxEloMeta } from "/root/gastos-gub-uy/app/pages/investigaciones/datacenter-google.vue?macro=true";
import { default as empresas_45senaladasUG4N2Pd74Cla7hKDcfxiyagvi0khrkcu6uGwGmfcdxwMeta } from "/root/gastos-gub-uy/app/pages/investigaciones/empresas-senaladas.vue?macro=true";
import { default as suicidios_45recursos13aZMlfUcLHxLhaJNUqtkvW7x4PVLJ8Q2zqym2lzF_45QMeta } from "/root/gastos-gub-uy/app/pages/investigaciones/suicidios-recursos.vue?macro=true";
import { default as vivienda_45promovidaNsGAzP9bI0zL3QivQ1PZGY180kH2RLAXo_2P8_oOofEMeta } from "/root/gastos-gub-uy/app/pages/investigaciones/vivienda-promovida.vue?macro=true";
import { default as proveedores_45errores_45cargaq3kgbdUurgXdBXrk3tgyTAkDWuubwy6javAi4XQGFksMeta } from "/root/gastos-gub-uy/app/pages/analytics/proveedores-errores-carga.vue?macro=true";
import { default as frigorifico_45saturnon0bucfhxt76AHqOMOvF_oDe08cPxy644S1EFytiK2SEMeta } from "/root/gastos-gub-uy/app/pages/investigaciones/frigorifico-saturno.vue?macro=true";
import { default as mensajes_45del_45estado7i_ptavjrGCPdmjCVo8GOOEpy1wuOMt8Nr0UNIElcE0Meta } from "/root/gastos-gub-uy/app/pages/investigaciones/mensajes-del-estado.vue?macro=true";
import { default as competencia_45aparenteBBUuoJbBPv_L8_45WJiOPEC05l9IHkOkA3MSOSpxJtCsQMeta } from "/root/gastos-gub-uy/app/pages/investigaciones/competencia-aparente.vue?macro=true";
import { default as intendencia_45montevideo1BiJ6sHyBsQHLsg_45muE1sH8ZWHn8IN7_45mXHKLbLrxvgMeta } from "/root/gastos-gub-uy/app/pages/investigaciones/intendencia-montevideo.vue?macro=true";
import { default as component_45stubbXObhPZQBWRwn2Po_45bGeEyC3W9aT8fw0OyIIuPe0oIQMeta } from "/root/gastos-gub-uy/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbXObhPZQBWRwn2Po_45bGeEyC3W9aT8fw0OyIIuPe0oIQ } from "/root/gastos-gub-uy/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "about___es",
    path: "/about",
    component: () => import("/root/gastos-gub-uy/app/pages/about.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    component: () => import("/root/gastos-gub-uy/app/pages/about.vue")
  },
  {
    name: "index___es",
    path: "/",
    component: () => import("/root/gastos-gub-uy/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/root/gastos-gub-uy/app/pages/index.vue")
  },
  {
    name: "login___es",
    path: "/login",
    meta: {"middleware":"guest"},
    component: () => import("/root/gastos-gub-uy/app/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: {"middleware":"guest"},
    component: () => import("/root/gastos-gub-uy/app/pages/login.vue")
  },
  {
    name: "pauta___es",
    path: "/pauta",
    component: () => import("/root/gastos-gub-uy/app/pages/pauta.vue")
  },
  {
    name: "pauta___en",
    path: "/en/pauta",
    component: () => import("/root/gastos-gub-uy/app/pages/pauta.vue")
  },
  {
    name: "cookies___es",
    path: "/cookies",
    component: () => import("/root/gastos-gub-uy/app/pages/cookies.vue")
  },
  {
    name: "cookies___en",
    path: "/en/cookies",
    component: () => import("/root/gastos-gub-uy/app/pages/cookies.vue")
  },
  {
    name: "registro___es",
    path: "/registro",
    meta: {"middleware":"guest"},
    component: () => import("/root/gastos-gub-uy/app/pages/registro.vue")
  },
  {
    name: "registro___en",
    path: "/en/registro",
    meta: {"middleware":"guest"},
    component: () => import("/root/gastos-gub-uy/app/pages/registro.vue")
  },
  {
    name: "terminos___es",
    path: "/terminos",
    component: () => import("/root/gastos-gub-uy/app/pages/terminos.vue")
  },
  {
    name: "terminos___en",
    path: "/en/terminos",
    component: () => import("/root/gastos-gub-uy/app/pages/terminos.vue")
  },
  {
    name: "app___es",
    path: "/app",
    meta: {"middleware":"auth"},
    component: () => import("/root/gastos-gub-uy/app/pages/app/index.vue")
  },
  {
    name: "app___en",
    path: "/en/app",
    meta: {"middleware":"auth"},
    component: () => import("/root/gastos-gub-uy/app/pages/app/index.vue")
  },
  {
    name: "recuperar___es",
    path: "/recuperar",
    meta: {"middleware":"guest"},
    component: () => import("/root/gastos-gub-uy/app/pages/recuperar.vue")
  },
  {
    name: "recuperar___en",
    path: "/en/recuperar",
    meta: {"middleware":"guest"},
    component: () => import("/root/gastos-gub-uy/app/pages/recuperar.vue")
  },
  {
    name: "app-cuenta___es",
    path: "/app/cuenta",
    meta: {"middleware":"auth"},
    component: () => import("/root/gastos-gub-uy/app/pages/app/cuenta.vue")
  },
  {
    name: "app-cuenta___en",
    path: "/en/app/cuenta",
    meta: {"middleware":"auth"},
    component: () => import("/root/gastos-gub-uy/app/pages/app/cuenta.vue")
  },
  {
    name: "blog___es",
    path: "/blog",
    component: () => import("/root/gastos-gub-uy/app/pages/blog/index.vue")
  },
  {
    name: "blog___en",
    path: "/en/blog",
    component: () => import("/root/gastos-gub-uy/app/pages/blog/index.vue")
  },
  {
    name: "developers___es",
    path: "/developers",
    component: () => import("/root/gastos-gub-uy/app/pages/developers.vue")
  },
  {
    name: "developers___en",
    path: "/en/developers",
    component: () => import("/root/gastos-gub-uy/app/pages/developers.vue")
  },
  {
    name: "privacidad___es",
    path: "/privacidad",
    component: () => import("/root/gastos-gub-uy/app/pages/privacidad.vue")
  },
  {
    name: "privacidad___en",
    path: "/en/privacidad",
    component: () => import("/root/gastos-gub-uy/app/pages/privacidad.vue")
  },
  {
    name: "app-alertas___es",
    path: "/app/alertas",
    meta: {"middleware":"auth"},
    component: () => import("/root/gastos-gub-uy/app/pages/app/alertas.vue")
  },
  {
    name: "app-alertas___en",
    path: "/en/app/alertas",
    meta: {"middleware":"auth"},
    component: () => import("/root/gastos-gub-uy/app/pages/app/alertas.vue")
  },
  {
    name: "blog-slug___es",
    path: "/blog/:slug()",
    component: () => import("/root/gastos-gub-uy/app/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___en",
    path: "/en/blog/:slug()",
    component: () => import("/root/gastos-gub-uy/app/pages/blog/[slug].vue")
  },
  {
    name: "buyers-id___es",
    path: "/buyers/:id()",
    component: () => import("/root/gastos-gub-uy/app/pages/buyers/[id].vue")
  },
  {
    name: "buyers-id___en",
    path: "/en/buyers/:id()",
    component: () => import("/root/gastos-gub-uy/app/pages/buyers/[id].vue")
  },
  {
    name: "comparativa___es",
    path: "/comparativa",
    component: () => import("/root/gastos-gub-uy/app/pages/comparativa.vue")
  },
  {
    name: "comparativa___en",
    path: "/en/comparativa",
    component: () => import("/root/gastos-gub-uy/app/pages/comparativa.vue")
  },
  {
    name: "unsubscribe___es",
    path: "/unsubscribe",
    component: () => import("/root/gastos-gub-uy/app/pages/unsubscribe.vue")
  },
  {
    name: "unsubscribe___en",
    path: "/en/unsubscribe",
    component: () => import("/root/gastos-gub-uy/app/pages/unsubscribe.vue")
  },
  {
    name: "app-api-keys___es",
    path: "/app/api-keys",
    meta: {"middleware":"auth"},
    component: () => import("/root/gastos-gub-uy/app/pages/app/api-keys.vue")
  },
  {
    name: "app-api-keys___en",
    path: "/en/app/api-keys",
    meta: {"middleware":"auth"},
    component: () => import("/root/gastos-gub-uy/app/pages/app/api-keys.vue")
  },
  {
    name: "app-webhooks___es",
    path: "/app/webhooks",
    meta: {"middleware":"auth"},
    component: () => import("/root/gastos-gub-uy/app/pages/app/webhooks.vue")
  },
  {
    name: "app-webhooks___en",
    path: "/en/app/webhooks",
    meta: {"middleware":"auth"},
    component: () => import("/root/gastos-gub-uy/app/pages/app/webhooks.vue")
  },
  {
    name: "buyers___es",
    path: "/buyers",
    component: () => import("/root/gastos-gub-uy/app/pages/buyers/index.vue")
  },
  {
    name: "buyers___en",
    path: "/en/buyers",
    component: () => import("/root/gastos-gub-uy/app/pages/buyers/index.vue")
  },
  {
    name: "curros___es",
    path: "/curros",
    component: () => import("/root/gastos-gub-uy/app/pages/curros/index.vue")
  },
  {
    name: "curros___en",
    path: "/en/curros",
    component: () => import("/root/gastos-gub-uy/app/pages/curros/index.vue")
  },
  {
    name: "estadisticas___es",
    path: "/estadisticas",
    component: () => import("/root/gastos-gub-uy/app/pages/estadisticas.vue")
  },
  {
    name: "estadisticas___en",
    path: "/en/estadisticas",
    component: () => import("/root/gastos-gub-uy/app/pages/estadisticas.vue")
  },
  {
    name: "gastos___es",
    path: "/gastos",
    component: () => import("/root/gastos-gub-uy/app/pages/gastos/index.vue")
  },
  {
    name: "gastos___en",
    path: "/en/gastos",
    component: () => import("/root/gastos-gub-uy/app/pages/gastos/index.vue")
  },
  {
    name: "auth-callback___es",
    path: "/auth/callback",
    meta: {"middleware":"guest"},
    component: () => import("/root/gastos-gub-uy/app/pages/auth/callback.vue")
  },
  {
    name: "auth-callback___en",
    path: "/en/auth/callback",
    meta: {"middleware":"guest"},
    component: () => import("/root/gastos-gub-uy/app/pages/auth/callback.vue")
  },
  {
    name: "colaboradores___es",
    path: "/colaboradores",
    component: () => import("/root/gastos-gub-uy/app/pages/colaboradores.vue")
  },
  {
    name: "colaboradores___en",
    path: "/en/colaboradores",
    component: () => import("/root/gastos-gub-uy/app/pages/colaboradores.vue")
  },
  {
    name: "curros-slug___es",
    path: "/curros/:slug()",
    component: () => import("/root/gastos-gub-uy/app/pages/curros/[slug].vue")
  },
  {
    name: "curros-slug___en",
    path: "/en/curros/:slug()",
    component: () => import("/root/gastos-gub-uy/app/pages/curros/[slug].vue")
  },
  {
    name: "gastos-year___es",
    path: "/gastos/:year()",
    component: () => import("/root/gastos-gub-uy/app/pages/gastos/[year].vue")
  },
  {
    name: "gastos-year___en",
    path: "/en/gastos/:year()",
    component: () => import("/root/gastos-gub-uy/app/pages/gastos/[year].vue")
  },
  {
    name: "analytics-mapa___es",
    path: "/analytics/mapa",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/mapa.vue")
  },
  {
    name: "analytics-mapa___en",
    path: "/en/analytics/mapa",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/mapa.vue")
  },
  {
    name: "app-calendario___es",
    path: "/app/calendario",
    meta: {"middleware":"auth"},
    component: () => import("/root/gastos-gub-uy/app/pages/app/calendario.vue")
  },
  {
    name: "app-calendario___en",
    path: "/en/app/calendario",
    meta: {"middleware":"auth"},
    component: () => import("/root/gastos-gub-uy/app/pages/app/calendario.vue")
  },
  {
    name: "contracts-id___es",
    path: "/contracts/:id()",
    component: () => import("/root/gastos-gub-uy/app/pages/contracts/[id].vue")
  },
  {
    name: "contracts-id___en",
    path: "/en/contracts/:id()",
    component: () => import("/root/gastos-gub-uy/app/pages/contracts/[id].vue")
  },
  {
    name: "llamados___es",
    path: "/llamados",
    component: () => import("/root/gastos-gub-uy/app/pages/llamados/index.vue")
  },
  {
    name: "llamados___en",
    path: "/en/llamados",
    component: () => import("/root/gastos-gub-uy/app/pages/llamados/index.vue")
  },
  {
    name: "products___es",
    path: "/products",
    component: () => import("/root/gastos-gub-uy/app/pages/products/index.vue")
  },
  {
    name: "products___en",
    path: "/en/products",
    component: () => import("/root/gastos-gub-uy/app/pages/products/index.vue")
  },
  {
    name: "analytics___es",
    path: "/analytics",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/index.vue")
  },
  {
    name: "analytics___en",
    path: "/en/analytics",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/index.vue")
  },
  {
    name: "contactos___es",
    path: "/contactos",
    component: () => import("/root/gastos-gub-uy/app/pages/contactos/index.vue")
  },
  {
    name: "contactos___en",
    path: "/en/contactos",
    component: () => import("/root/gastos-gub-uy/app/pages/contactos/index.vue")
  },
  {
    name: "contracts___es",
    path: "/contracts",
    component: () => import("/root/gastos-gub-uy/app/pages/contracts/index.vue")
  },
  {
    name: "contracts___en",
    path: "/en/contracts",
    component: () => import("/root/gastos-gub-uy/app/pages/contracts/index.vue")
  },
  {
    name: "products-code___es",
    path: "/products/:code()",
    component: () => import("/root/gastos-gub-uy/app/pages/products/[code].vue")
  },
  {
    name: "products-code___en",
    path: "/en/products/:code()",
    component: () => import("/root/gastos-gub-uy/app/pages/products/[code].vue")
  },
  {
    name: "suppliers___es",
    path: "/suppliers",
    component: () => import("/root/gastos-gub-uy/app/pages/suppliers/index.vue")
  },
  {
    name: "suppliers___en",
    path: "/en/suppliers",
    component: () => import("/root/gastos-gub-uy/app/pages/suppliers/index.vue")
  },
  {
    name: "analytics-agenda___es",
    path: "/analytics/agenda",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/agenda.vue")
  },
  {
    name: "analytics-agenda___en",
    path: "/en/analytics/agenda",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/agenda.vue")
  },
  {
    name: "analytics-genero___es",
    path: "/analytics/genero",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/genero.vue")
  },
  {
    name: "analytics-genero___en",
    path: "/en/analytics/genero",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/genero.vue")
  },
  {
    name: "analytics-omisos___es",
    path: "/analytics/omisos",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/omisos.vue")
  },
  {
    name: "analytics-omisos___en",
    path: "/en/analytics/omisos",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/omisos.vue")
  },
  {
    name: "parlamento___es",
    path: "/parlamento",
    component: () => import("/root/gastos-gub-uy/app/pages/parlamento/index.vue")
  },
  {
    name: "parlamento___en",
    path: "/en/parlamento",
    component: () => import("/root/gastos-gub-uy/app/pages/parlamento/index.vue")
  },
  {
    name: "analytics-senales___es",
    path: "/analytics/senales",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/senales.vue")
  },
  {
    name: "analytics-senales___en",
    path: "/en/analytics/senales",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/senales.vue")
  },
  {
    name: "suppliers-id___es",
    path: "/suppliers/:id(.*)*",
    component: () => import("/root/gastos-gub-uy/app/pages/suppliers/[...id].vue")
  },
  {
    name: "suppliers-id___en",
    path: "/en/suppliers/:id(.*)*",
    component: () => import("/root/gastos-gub-uy/app/pages/suppliers/[...id].vue")
  },
  {
    name: "analytics-partidos___es",
    path: "/analytics/partidos",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/partidos.vue")
  },
  {
    name: "analytics-partidos___en",
    path: "/en/analytics/partidos",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/partidos.vue")
  },
  {
    name: "app-notificaciones___es",
    path: "/app/notificaciones",
    meta: {"middleware":"auth"},
    component: () => import("/root/gastos-gub-uy/app/pages/app/notificaciones.vue")
  },
  {
    name: "app-notificaciones___en",
    path: "/en/app/notificaciones",
    meta: {"middleware":"auth"},
    component: () => import("/root/gastos-gub-uy/app/pages/app/notificaciones.vue")
  },
  {
    name: "analytics-anomalies___es",
    path: "/analytics/anomalies",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/anomalies.vue")
  },
  {
    name: "analytics-anomalies___en",
    path: "/en/analytics/anomalies",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/anomalies.vue")
  },
  {
    name: "analytics-encuestas___es",
    path: "/analytics/encuestas",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/encuestas.vue")
  },
  {
    name: "analytics-encuestas___en",
    path: "/en/analytics/encuestas",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/encuestas.vue")
  },
  {
    name: "analytics-sanciones___es",
    path: "/analytics/sanciones",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/sanciones.vue")
  },
  {
    name: "analytics-sanciones___en",
    path: "/en/analytics/sanciones",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/sanciones.vue")
  },
  {
    name: "llamados-compraId___es",
    path: "/llamados/:compraId()",
    component: () => import("/root/gastos-gub-uy/app/pages/llamados/[compraId].vue")
  },
  {
    name: "llamados-compraId___en",
    path: "/en/llamados/:compraId()",
    component: () => import("/root/gastos-gub-uy/app/pages/llamados/[compraId].vue")
  },
  {
    name: "analytics-organismos___es",
    path: "/analytics/organismos",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/organismos.vue")
  },
  {
    name: "analytics-organismos___en",
    path: "/en/analytics/organismos",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/organismos.vue")
  },
  {
    name: "analytics-sentencias___es",
    path: "/analytics/sentencias",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/sentencias.vue")
  },
  {
    name: "analytics-sentencias___en",
    path: "/en/analytics/sentencias",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/sentencias.vue")
  },
  {
    name: "parlamento-videoId___es",
    path: "/parlamento/:videoId()",
    component: () => import("/root/gastos-gub-uy/app/pages/parlamento/[videoId].vue")
  },
  {
    name: "parlamento-videoId___en",
    path: "/en/parlamento/:videoId()",
    component: () => import("/root/gastos-gub-uy/app/pages/parlamento/[videoId].vue")
  },
  {
    name: "recopilatorios___es",
    path: "/recopilatorios",
    component: () => import("/root/gastos-gub-uy/app/pages/recopilatorios/index.vue")
  },
  {
    name: "recopilatorios___en",
    path: "/en/recopilatorios",
    component: () => import("/root/gastos-gub-uy/app/pages/recopilatorios/index.vue")
  },
  {
    name: "analytics-competencia___es",
    path: "/analytics/competencia",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/competencia.vue")
  },
  {
    name: "analytics-competencia___en",
    path: "/en/analytics/competencia",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/competencia.vue")
  },
  {
    name: "analytics-unexplained___es",
    path: "/analytics/unexplained",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/unexplained.vue")
  },
  {
    name: "analytics-unexplained___en",
    path: "/en/analytics/unexplained",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/unexplained.vue")
  },
  {
    name: "canales-youtube___es",
    path: "/canales-youtube",
    component: () => import("/root/gastos-gub-uy/app/pages/canales-youtube/index.vue")
  },
  {
    name: "canales-youtube___en",
    path: "/en/canales-youtube",
    component: () => import("/root/gastos-gub-uy/app/pages/canales-youtube/index.vue")
  },
  {
    name: "investigaciones___es",
    path: "/investigaciones",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/index.vue")
  },
  {
    name: "investigaciones___en",
    path: "/en/investigaciones",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/index.vue")
  },
  {
    name: "investigaciones-sunca___es",
    path: "/investigaciones/sunca",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/sunca.vue")
  },
  {
    name: "investigaciones-sunca___en",
    path: "/en/investigaciones/sunca",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/sunca.vue")
  },
  {
    name: "recopilatorios-slug___es",
    path: "/recopilatorios/:slug()",
    component: () => import("/root/gastos-gub-uy/app/pages/recopilatorios/[slug].vue")
  },
  {
    name: "recopilatorios-slug___en",
    path: "/en/recopilatorios/:slug()",
    component: () => import("/root/gastos-gub-uy/app/pages/recopilatorios/[slug].vue")
  },
  {
    name: "analytics-anticipacion___es",
    path: "/analytics/anticipacion",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/anticipacion.vue")
  },
  {
    name: "analytics-anticipacion___en",
    path: "/en/analytics/anticipacion",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/anticipacion.vue")
  },
  {
    name: "analytics-intendencias___es",
    path: "/analytics/intendencias",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/intendencias.vue")
  },
  {
    name: "analytics-intendencias___en",
    path: "/en/analytics/intendencias",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/intendencias.vue")
  },
  {
    name: "canales-youtube-slug___es",
    path: "/canales-youtube/:slug()",
    component: () => import("/root/gastos-gub-uy/app/pages/canales-youtube/[slug].vue")
  },
  {
    name: "canales-youtube-slug___en",
    path: "/en/canales-youtube/:slug()",
    component: () => import("/root/gastos-gub-uy/app/pages/canales-youtube/[slug].vue")
  },
  {
    name: "newsletter-unsubscribe___es",
    path: "/newsletter/unsubscribe",
    component: () => import("/root/gastos-gub-uy/app/pages/newsletter/unsubscribe.vue")
  },
  {
    name: "newsletter-unsubscribe___en",
    path: "/en/newsletter/unsubscribe",
    component: () => import("/root/gastos-gub-uy/app/pages/newsletter/unsubscribe.vue")
  },
  {
    name: "analytics-como-reportar___es",
    path: "/analytics/como-reportar",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/como-reportar.vue")
  },
  {
    name: "analytics-como-reportar___en",
    path: "/en/analytics/como-reportar",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/como-reportar.vue")
  },
  {
    name: "analytics-errores-carga___es",
    path: "/analytics/errores-carga",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/errores-carga.vue")
  },
  {
    name: "analytics-errores-carga___en",
    path: "/en/analytics/errores-carga",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/errores-carga.vue")
  },
  {
    name: "analytics-rss-anomalias___es",
    path: "/analytics/rss-anomalias",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/rss-anomalias.vue")
  },
  {
    name: "analytics-rss-anomalias___en",
    path: "/en/analytics/rss-anomalias",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/rss-anomalias.vue")
  },
  {
    name: "investigaciones-casinos___es",
    path: "/investigaciones/casinos",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/casinos.vue")
  },
  {
    name: "investigaciones-casinos___en",
    path: "/en/investigaciones/casinos",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/casinos.vue")
  },
  {
    name: "analytics-evolucion-gasto___es",
    path: "/analytics/evolucion-gasto",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/evolucion-gasto.vue")
  },
  {
    name: "analytics-evolucion-gasto___en",
    path: "/en/analytics/evolucion-gasto",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/evolucion-gasto.vue")
  },
  {
    name: "comparativa-transparencia___es",
    path: "/comparativa-transparencia",
    component: () => import("/root/gastos-gub-uy/app/pages/comparativa-transparencia.vue")
  },
  {
    name: "comparativa-transparencia___en",
    path: "/en/comparativa-transparencia",
    component: () => import("/root/gastos-gub-uy/app/pages/comparativa-transparencia.vue")
  },
  {
    name: "investigaciones-hallazgos___es",
    path: "/investigaciones/hallazgos",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/hallazgos.vue")
  },
  {
    name: "investigaciones-hallazgos___en",
    path: "/en/investigaciones/hallazgos",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/hallazgos.vue")
  },
  {
    name: "investigaciones-suicidios___es",
    path: "/investigaciones/suicidios",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/suicidios.vue")
  },
  {
    name: "investigaciones-suicidios___en",
    path: "/en/investigaciones/suicidios",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/suicidios.vue")
  },
  {
    name: "investigaciones-tv-ciudad___es",
    path: "/investigaciones/tv-ciudad",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/tv-ciudad.vue")
  },
  {
    name: "investigaciones-tv-ciudad___en",
    path: "/en/investigaciones/tv-ciudad",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/tv-ciudad.vue")
  },
  {
    name: "analytics-tribunal-cuentas___es",
    path: "/analytics/tribunal-cuentas",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/tribunal-cuentas.vue")
  },
  {
    name: "analytics-tribunal-cuentas___en",
    path: "/en/analytics/tribunal-cuentas",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/tribunal-cuentas.vue")
  },
  {
    name: "investigaciones-monopolios___es",
    path: "/investigaciones/monopolios",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/monopolios.vue")
  },
  {
    name: "investigaciones-monopolios___en",
    path: "/en/investigaciones/monopolios",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/monopolios.vue")
  },
  {
    name: "proveedores-contactos-mapa___es",
    path: "/proveedores/contactos/mapa",
    component: () => import("/root/gastos-gub-uy/app/pages/proveedores/contactos/mapa.vue")
  },
  {
    name: "proveedores-contactos-mapa___en",
    path: "/en/proveedores/contactos/mapa",
    component: () => import("/root/gastos-gub-uy/app/pages/proveedores/contactos/mapa.vue")
  },
  {
    name: "investigaciones-casos___es",
    path: "/investigaciones/casos",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/casos/index.vue")
  },
  {
    name: "investigaciones-casos___en",
    path: "/en/investigaciones/casos",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/casos/index.vue")
  },
  {
    name: "proveedores-contactos___es",
    path: "/proveedores/contactos",
    component: () => import("/root/gastos-gub-uy/app/pages/proveedores/contactos/index.vue")
  },
  {
    name: "proveedores-contactos___en",
    path: "/en/proveedores/contactos",
    component: () => import("/root/gastos-gub-uy/app/pages/proveedores/contactos/index.vue")
  },
  {
    name: "investigaciones-casos-slug___es",
    path: "/investigaciones/casos/:slug()",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/casos/[slug].vue")
  },
  {
    name: "investigaciones-casos-slug___en",
    path: "/en/investigaciones/casos/:slug()",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/casos/[slug].vue")
  },
  {
    name: "investigaciones-diario___es",
    path: "/investigaciones/diario",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/diario/index.vue")
  },
  {
    name: "investigaciones-diario___en",
    path: "/en/investigaciones/diario",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/diario/index.vue")
  },
  {
    name: "investigaciones-documento-fa___es",
    path: "/investigaciones/documento-fa",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/documento-fa.vue")
  },
  {
    name: "investigaciones-documento-fa___en",
    path: "/en/investigaciones/documento-fa",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/documento-fa.vue")
  },
  {
    name: "investigaciones-mejor-o-peor___es",
    path: "/investigaciones/mejor-o-peor",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/mejor-o-peor.vue")
  },
  {
    name: "investigaciones-mejor-o-peor___en",
    path: "/en/investigaciones/mejor-o-peor",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/mejor-o-peor.vue")
  },
  {
    name: "investigaciones-temas-tema___es",
    path: "/investigaciones/temas/:tema()",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/temas/[tema].vue")
  },
  {
    name: "investigaciones-temas-tema___en",
    path: "/en/investigaciones/temas/:tema()",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/temas/[tema].vue")
  },
  {
    name: "investigaciones-diario-slug___es",
    path: "/investigaciones/diario/:slug()",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/diario/[slug].vue")
  },
  {
    name: "investigaciones-diario-slug___en",
    path: "/en/investigaciones/diario/:slug()",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/diario/[slug].vue")
  },
  {
    name: "analytics-proveedores-anomalias___es",
    path: "/analytics/proveedores-anomalias",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/proveedores-anomalias.vue")
  },
  {
    name: "analytics-proveedores-anomalias___en",
    path: "/en/analytics/proveedores-anomalias",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/proveedores-anomalias.vue")
  },
  {
    name: "investigaciones-gasto-en-genero___es",
    path: "/investigaciones/gasto-en-genero",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/gasto-en-genero.vue")
  },
  {
    name: "investigaciones-gasto-en-genero___en",
    path: "/en/investigaciones/gasto-en-genero",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/gasto-en-genero.vue")
  },
  {
    name: "investigaciones-antel-cuadrillas___es",
    path: "/investigaciones/antel-cuadrillas",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/antel-cuadrillas.vue")
  },
  {
    name: "investigaciones-antel-cuadrillas___en",
    path: "/en/investigaciones/antel-cuadrillas",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/antel-cuadrillas.vue")
  },
  {
    name: "investigaciones-asse-ambulancias___es",
    path: "/investigaciones/asse-ambulancias",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/asse-ambulancias.vue")
  },
  {
    name: "investigaciones-asse-ambulancias___en",
    path: "/en/investigaciones/asse-ambulancias",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/asse-ambulancias.vue")
  },
  {
    name: "investigaciones-canales-privados___es",
    path: "/investigaciones/canales-privados",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/canales-privados.vue")
  },
  {
    name: "investigaciones-canales-privados___en",
    path: "/en/investigaciones/canales-privados",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/canales-privados.vue")
  },
  {
    name: "investigaciones-casinos-cortesia___es",
    path: "/investigaciones/casinos-cortesia",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/casinos-cortesia.vue")
  },
  {
    name: "investigaciones-casinos-cortesia___en",
    path: "/en/investigaciones/casinos-cortesia",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/casinos-cortesia.vue")
  },
  {
    name: "investigaciones-soriano-talleres___es",
    path: "/investigaciones/soriano-talleres",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/soriano-talleres.vue")
  },
  {
    name: "investigaciones-soriano-talleres___en",
    path: "/en/investigaciones/soriano-talleres",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/soriano-talleres.vue")
  },
  {
    name: "investigaciones-datacenter-google___es",
    path: "/investigaciones/datacenter-google",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/datacenter-google.vue")
  },
  {
    name: "investigaciones-datacenter-google___en",
    path: "/en/investigaciones/datacenter-google",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/datacenter-google.vue")
  },
  {
    name: "investigaciones-empresas-senaladas___es",
    path: "/investigaciones/empresas-senaladas",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/empresas-senaladas.vue")
  },
  {
    name: "investigaciones-empresas-senaladas___en",
    path: "/en/investigaciones/empresas-senaladas",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/empresas-senaladas.vue")
  },
  {
    name: "investigaciones-suicidios-recursos___es",
    path: "/investigaciones/suicidios-recursos",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/suicidios-recursos.vue")
  },
  {
    name: "investigaciones-suicidios-recursos___en",
    path: "/en/investigaciones/suicidios-recursos",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/suicidios-recursos.vue")
  },
  {
    name: "investigaciones-vivienda-promovida___es",
    path: "/investigaciones/vivienda-promovida",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/vivienda-promovida.vue")
  },
  {
    name: "investigaciones-vivienda-promovida___en",
    path: "/en/investigaciones/vivienda-promovida",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/vivienda-promovida.vue")
  },
  {
    name: "analytics-proveedores-errores-carga___es",
    path: "/analytics/proveedores-errores-carga",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/proveedores-errores-carga.vue")
  },
  {
    name: "analytics-proveedores-errores-carga___en",
    path: "/en/analytics/proveedores-errores-carga",
    component: () => import("/root/gastos-gub-uy/app/pages/analytics/proveedores-errores-carga.vue")
  },
  {
    name: "investigaciones-frigorifico-saturno___es",
    path: "/investigaciones/frigorifico-saturno",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/frigorifico-saturno.vue")
  },
  {
    name: "investigaciones-frigorifico-saturno___en",
    path: "/en/investigaciones/frigorifico-saturno",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/frigorifico-saturno.vue")
  },
  {
    name: "investigaciones-mensajes-del-estado___es",
    path: "/investigaciones/mensajes-del-estado",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/mensajes-del-estado.vue")
  },
  {
    name: "investigaciones-mensajes-del-estado___en",
    path: "/en/investigaciones/mensajes-del-estado",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/mensajes-del-estado.vue")
  },
  {
    name: "investigaciones-competencia-aparente___es",
    path: "/investigaciones/competencia-aparente",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/competencia-aparente.vue")
  },
  {
    name: "investigaciones-competencia-aparente___en",
    path: "/en/investigaciones/competencia-aparente",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/competencia-aparente.vue")
  },
  {
    name: "investigaciones-intendencia-montevideo___es",
    path: "/investigaciones/intendencia-montevideo",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/intendencia-montevideo.vue")
  },
  {
    name: "investigaciones-intendencia-montevideo___en",
    path: "/en/investigaciones/intendencia-montevideo",
    component: () => import("/root/gastos-gub-uy/app/pages/investigaciones/intendencia-montevideo.vue")
  },
  {
    name: component_45stubbXObhPZQBWRwn2Po_45bGeEyC3W9aT8fw0OyIIuPe0oIQMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubbXObhPZQBWRwn2Po_45bGeEyC3W9aT8fw0OyIIuPe0oIQ
  },
  {
    name: component_45stubbXObhPZQBWRwn2Po_45bGeEyC3W9aT8fw0OyIIuPe0oIQMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubbXObhPZQBWRwn2Po_45bGeEyC3W9aT8fw0OyIIuPe0oIQ
  }
]